import { render, staticRenderFns } from "./DatepickerH5.vue?vue&type=template&id=18274271&scoped=true"
import script from "./DatepickerH5.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatepickerH5.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18274271",
  null
  
)

export default component.exports